// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudUpload1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CloudUpload1/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.5 13a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 13h-2.499V9.413l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L9 9.414V13H5.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 13h2v5a1 1 0 1 1-2 0v-5Z"
}));
export default CloudUpload1Icon;